import {TypingEnum} from 'typing-enum'

export class ORDER_TYPE extends TypingEnum {
  static readonly resourcePackage = new ORDER_TYPE(1, '资源包')
  private static _ = this.finish()
}
